<main class="table-page table-page--fill" dir="rtl">
  <header class="header">
    <div class="title-row">
      <button type="button" class="back" [routerLink]="parentUserId != -1 ? ['/saveUser'] : ['/']" aria-label="بازگشت">
        <i class="fa fa-arrow-right" aria-hidden="true"></i>
      </button>
      <h1 class="title">{{ isSchoolMode ? 'مدیریت کاربران مدارس' : parentUserId != -1 ? 'کاربران زیرمجموعه' : 'مدیریت کاربران' }}</h1>
      <div class="actions" *ngIf="!isSchoolMode">
        <button type="button" class="btn-round btn-round-primary" data-bs-toggle="modal" data-bs-target="#addUser"
          [disabled]="listLoading" aria-label="ثبت کاربر" (mouseenter)="tooltip.show($event, 'ثبت کاربر')" (mouseleave)="tooltip.hide()" (focus)="tooltip.show($event, 'ثبت کاربر')" (blur)="tooltip.hide()">
          <i class="fa fa-plus" aria-hidden="true"></i>
        </button>
      </div>
    </div>
  </header>

  <section class="card" aria-label="فهرست کاربران" [attr.aria-busy]="listLoading">
    <div class="table-toolbar">
      <div class="search-wrap">
        <input class="control" type="search" [ngModel]="searchText" (ngModelChange)="searchUsers($event)"
          [disabled]="listLoading" aria-label="جستجو در کاربران" placeholder="جستجو در جدول: نام و نام خانوادگی، نام کاربری، حوزه خدمت...">
        <i class="fa fa-search" aria-hidden="true"></i>
      </div>
      <div class="toolbar-actions">
        <button type="button" class="btn btn-soft" (click)="exportExcel('excel-table-area-main')" [disabled]="listLoading || !visibleUsers.length">
          <i class="fa fa-file-excel-o" aria-hidden="true"></i> خروجی اکسل
        </button>
      </div>
    </div>
    <div class="body">
      <div class="loader" [class.show]="listLoading" role="status" aria-live="polite">
        <div class="spinner"></div><span>در حال دریافت اطلاعات…</span>
      </div>
      <div id="stError" class="state error" [class.show]="!listLoading && hasError" role="alert">
        <div class="ico-big"><i class="fa fa-exclamation-triangle" aria-hidden="true"></i></div>
        <h2 class="h6">دریافت اطلاعات با خطا مواجه شد</h2>
        <span class="muted">اتصال به سرور را بررسی و دوباره تلاش کنید.</span>
        <button type="button" class="btn btn-primary retry" (click)="reloadUsers()">تلاش مجدد</button>
      </div>
      <div id="stEmpty" class="state" [class.show]="!listLoading && !hasError && !visibleUsers.length" role="status">
        <div class="ico-big"><i class="fa fa-inbox" aria-hidden="true"></i></div>
        <h2 class="h6">{{ searchText.trim() ? 'با این فیلترها نتیجه‌ای پیدا نشد!' : 'کاربری برای نمایش وجود ندارد' }}</h2>
        <span class="muted">{{ searchText.trim() ? 'عبارت جستجو را تغییر دهید و دوباره تلاش کنید.' : 'اطلاعات کاربران پس از ثبت در این بخش نمایش داده می‌شود.' }}</span>
        <div class="empty-actions" *ngIf="searchText.trim()">
          <button type="button" class="btn btn-primary" (click)="searchUsers('')">حذف فیلتر</button>
        </div>
      </div>
      <div class="table-scroll" [hidden]="hasError || (!listLoading && !visibleUsers.length)">
        <table id="excel-table-area-main">
          <thead><tr>
            <th scope="col" class="col-ops sticky-first">عملیات</th>
            <th scope="col" class="col-num">ردیف</th>
            <th scope="col" data-key="strFullName" [class.sorted]="sortKey === 'name'"
              [attr.aria-sort]="sortKey === 'name' ? (sortDirections.name ? 'ascending' : 'descending') : 'none'"
              [attr.aria-disabled]="listLoading" [attr.tabindex]="listLoading ? -1 : 0"
              (click)="!listLoading && sortUsers('name')" (keydown.enter)="!listLoading && sortUsers('name')"
              (keydown.space)="$event.preventDefault(); !listLoading && sortUsers('name')">
              <span class="th-in">نام و نام خانوادگی<i class="fa sort-ico" [ngClass]="sortKey === 'name' ? (sortDirections.name ? 'fa-sort-asc' : 'fa-sort-desc') : 'fa-sort'" aria-hidden="true"></i></span>
            </th>
            <th scope="col">نام کاربری</th>
            <th scope="col" *ngIf="!isSchoolMode">حوزه خدمتی</th>
            <th scope="col" *ngIf="!isSchoolMode" data-key="strEsterakEndDate" [class.sorted]="sortKey === 'date'"
              [attr.aria-sort]="sortKey === 'date' ? (sortDirections.date ? 'descending' : 'ascending') : 'none'"
              [attr.aria-disabled]="listLoading" [attr.tabindex]="listLoading ? -1 : 0"
              (click)="!listLoading && sortUsers('date')" (keydown.enter)="!listLoading && sortUsers('date')"
              (keydown.space)="$event.preventDefault(); !listLoading && sortUsers('date')">
              <span class="th-in">تاریخ پایان اعتبار<i class="fa sort-ico" [ngClass]="sortKey === 'date' ? (sortDirections.date ? 'fa-sort-desc' : 'fa-sort-asc') : 'fa-sort'" aria-hidden="true"></i></span>
            </th>
            <th scope="col" data-key="iInput" [class.sorted]="sortKey === 'input'"
              [attr.aria-sort]="sortKey === 'input' ? (sortDirections.input ? 'descending' : 'ascending') : 'none'"
              [attr.aria-disabled]="listLoading" [attr.tabindex]="listLoading ? -1 : 0"
              (click)="!listLoading && sortUsers('input')" (keydown.enter)="!listLoading && sortUsers('input')"
              (keydown.space)="$event.preventDefault(); !listLoading && sortUsers('input')">
              <span class="th-in">تعداد ورود<i class="fa sort-ico" [ngClass]="sortKey === 'input' ? (sortDirections.input ? 'fa-sort-desc' : 'fa-sort-asc') : 'fa-sort'" aria-hidden="true"></i></span>
            </th>
            <th scope="col" *ngIf="!isSchoolMode">حداکثر تعداد ورود</th>
            <th scope="col" data-key="strLastLoginDateTime" [class.sorted]="sortKey === 'lastLogin'"
              [attr.aria-sort]="sortKey === 'lastLogin' ? (sortDirections.lastLogin ? 'descending' : 'ascending') : 'none'"
              [attr.aria-disabled]="listLoading" [attr.tabindex]="listLoading ? -1 : 0"
              (click)="!listLoading && sortUsers('lastLogin')" (keydown.enter)="!listLoading && sortUsers('lastLogin')"
              (keydown.space)="$event.preventDefault(); !listLoading && sortUsers('lastLogin')">
              <span class="th-in">تاریخ آخرین ورود<i class="fa sort-ico" [ngClass]="sortKey === 'lastLogin' ? (sortDirections.lastLogin ? 'fa-sort-desc' : 'fa-sort-asc') : 'fa-sort'" aria-hidden="true"></i></span>
            </th>
            <th scope="col" *ngIf="!isSchoolMode">تعداد خودرو مجاز</th>
          </tr></thead>
          <tbody>
            <tr *ngFor="let item of pagedUsers; let i = index">
              <td class="col-ops sticky-first">
                <div class="row-ops">
                  <button type="button" class="ico" [disabled]="listLoading" (click)="prepareUserEdit(item)" data-bs-toggle="modal" data-bs-target="#addUser"
                    aria-label="ویرایش کاربر" (mouseenter)="tooltip.show($event, 'ویرایش کاربر')" (mouseleave)="tooltip.hide()" (focus)="tooltip.show($event, 'ویرایش کاربر')" (blur)="tooltip.hide()"><i class="fa fa-pencil" aria-hidden="true"></i></button>
                  <button type="button" class="ico" [disabled]="listLoading" (click)="loadUserPermissions(item.iSystemUser); openUserModal('access')"
                    aria-label="دسترسی کاربر" (mouseenter)="tooltip.show($event, 'دسترسی کاربر')" (mouseleave)="tooltip.hide()"
                    (focus)="tooltip.show($event, 'دسترسی کاربر')" (blur)="tooltip.hide()">
                    <i class="fa fa-hand-paper-o" aria-hidden="true"></i>
                  </button>
                  <button type="button" class="ico row-more" [disabled]="listLoading" (click)="toggleRowMenu($event, item)"
                    aria-label="عملیات بیشتر" aria-haspopup="menu" [attr.aria-expanded]="rowMenuRow === item" (mouseenter)="tooltip.show($event, 'عملیات بیشتر')" (mouseleave)="tooltip.hide()" (focus)="tooltip.show($event, 'عملیات بیشتر')" (blur)="tooltip.hide()">
                    <i class="fa fa-ellipsis-h" aria-hidden="true"></i>
                  </button>
                </div>
              </td>
              <td class="col-num">{{ (currentPage - 1) * pageSize + i + 1 | faNum }}</td>
              <td>{{ item.strFullName | faNum }}</td>
              <td>{{ item.strUserName | faNum }}</td>
              <td *ngIf="!isSchoolMode">{{ item.strMobile_strComment | faNum }}</td>
              <td *ngIf="!isSchoolMode">{{ item.strEsterakEndDate | faNum }}</td>
              <td>{{ item.iInput | number | faNum }}</td>
              <td *ngIf="!isSchoolMode">{{ item.iMaxInput | number | faNum }}</td>
              <td>{{ item.strLastLoginDateTime | faNum }}</td>
              <td *ngIf="!isSchoolMode">{{ item.iMaxMobile | number | faNum }}</td>
            </tr>
          </tbody>
          <tfoot><tr><td class="sticky-first"></td><td [attr.colspan]="isSchoolMode ? 5 : 9">تعداد کل: {{ visibleUsers.length | number | faNum }}</td></tr></tfoot>
        </table>
      </div>
    </div>
    <app-table-pagination [page]="currentPage" [pageSize]="pageSize" [totalItems]="visibleUsers.length"
      (pageChange)="closeRowMenu(false); currentPage = $event" (pageSizeChange)="closeRowMenu(false); pageSize = $event; currentPage = 1">
    </app-table-pagination>
  </section>

  <ng-template #rowMoreMenu>
    <div class="dd-menu compact" dir="rtl" role="menu" aria-label="عملیات کاربر" (keydown)="onRowMenuKeydown($event)">
      <button type="button" class="dd-item" role="menuitem" *ngIf="!isSchoolMode" (click)="loadUserVehicles(rowMenuRow.iSystemUser); openUserModal('carModal')"><i class="fa fa-car" aria-hidden="true"></i>اختصاص خودرو</button>
      <button type="button" class="dd-item" role="menuitem" *ngIf="(!isSchoolMode && permissions?.bUserManagment) || isSchoolMode" (click)="loadUserDomains(rowMenuRow); openUserModal('defineSchool')"><i class="fa fa-university" aria-hidden="true"></i>{{ isSchoolMode ? 'تعیین مدارس کاربر' : 'حوزه خدمتی کاربر' }}</button>
      <button type="button" class="dd-item" role="menuitem" *ngIf="!isSchoolMode && permissions?.bUserManagment_Group" (click)="openUserGroup(rowMenuRow); closeRowMenu(false)"><i class="fa fa-user-circle" aria-hidden="true"></i>گروه کاربری</button>
      <button type="button" class="dd-item" role="menuitem" *ngIf="!isSchoolMode && permissions?.bUserManagment" (click)="loadUserDomains(rowMenuRow, 'supervision_service'); openUserModal('supervision_service')"><i class="fa fa-building" aria-hidden="true"></i>حوزه‌های خدمتی تحت نظارت کاربر</button>
      <button type="button" class="dd-item" role="menuitem" (click)="loadUserActivity(rowMenuRow.iSystemUser); openUserModal('userActive')"><i class="fa fa-list" aria-hidden="true"></i>سابقه فعالیت کاربر</button>
      <button type="button" class="dd-item" role="menuitem" *ngIf="!isSchoolMode" (click)="openChildUsers(rowMenuRow.iSystemUser); closeRowMenu()"><i class="fa fa-users" aria-hidden="true"></i>زیرمجموعه</button>
      <button type="button" class="dd-item" role="menuitem" *ngIf="!isSchoolMode && permissions?.bSchoolService_UserGradeClass" (click)="loadUserClasses(rowMenuRow); closeRowMenu(false)"><i class="fa fa-building" aria-hidden="true"></i>کلاس کاربر</button>
      <div class="dd-sep" role="separator"></div>
      <button type="button" class="dd-item danger" role="menuitem" (click)="deleteUser(rowMenuRow.iSystemUser); closeRowMenu()"><i class="fa fa-trash" aria-hidden="true"></i>حذف کاربر</button>
    </div>
  </ng-template>
  <app-table-tooltip #tooltip></app-table-tooltip>
</main>

<!-- Create / edit user -->
<div class="modal fade rtl user-dialog user-dialog--form" dir="rtl" id="addUser" tabindex="-1" aria-labelledby="addUserTitle" aria-describedby="addUserDescription" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <div>
          <h2 class="modal-title" id="addUserTitle">{{ isEditing ? 'ویرایش کاربر' : 'ثبت کاربر' }}</h2>
          <span id="addUserDescription" class="muted">{{ isEditing ? 'اطلاعات و محدودیت‌های حساب کاربری را ویرایش کنید.' : 'ابتدا نام کاربری و شماره موبایل را وارد و بررسی کنید.' }}</span>
        </div>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="بستن"></button>
      </div>
      <div class="modal-body" [formGroup]="userForm">
        <div class="row g-3">
          <div class="col-12 col-md-6">
            <div class="user-field">
              <label for="userName" class="form-label">نام کاربری</label>
                <input id="userName" class="form-control" type="text" autocomplete="off" formControlName="strUserName" placeholder="نام کاربری">
            </div>
          </div>
          <div class="col-12 col-md-6">
            <div class="user-mobile-field">
              <div class="user-field">
                <label for="userMobile" class="form-label">شماره موبایل</label>
                <input id="userMobile" class="form-control" type="tel" inputmode="numeric" dir="ltr" formControlName="strMobile"
                  (keypress)="isNumber($event)" placeholder="09xxxxxxxxx">
              </div>
              <button type="button" class="btn btn-primary rounded-pill" (click)="verifyUserIdentity()" *ngIf="!isEditing">بررسی</button>
            </div>
          </div>
        </div>
        <ng-container *ngIf="showUserDetails">
          <h3 class="user-section-title user-section-title--divided">مشخصات و محدودیت‌های حساب</h3>
          <div class="row g-3">
            <div class="col-12 col-md-6">
              <div class="user-field">
                <label for="userFullName" class="form-label">نام و نام خانوادگی</label>
                <input id="userFullName" class="form-control" type="text" autocomplete="off" formControlName="strFullName">
              </div>
            </div>
            <div class="col-12 col-md-6">
              <div class="user-field">
                <label for="userPassword" class="form-label">رمز عبور</label>
                <input id="userPassword" class="form-control" type="password" autocomplete="new-password" formControlName="strPassword">
              </div>
            </div>
            <div class="col-12 col-md-6">
              <div class="user-field">
                <label for="userMaxInput" class="form-label">حداکثر تعداد ورود</label>
                <input id="userMaxInput" class="form-control" type="number" formControlName="iMaxInput">
              </div>
            </div>
            <div class="col-12 col-md-6">
              <div class="user-field">
                <label for="userMaxMobile" class="form-label">حداکثر تعداد خودرو مجاز</label>
                <input id="userMaxMobile" class="form-control" type="number" formControlName="iMaxMobile">
              </div>
            </div>
            <div class="col-12 col-md-6">
              <div class="user-field">
                <label for="userExpiry" class="form-label">تاریخ پایان اعتبار</label>
              <ng-persian-datepicker class="user-expiry-datepicker" [uiTheme]="'gray'" [uiHideAfterSelectDate]="true" [timeEnable]="false"
                [dateGregorianFormat]="'YYYY/MM/DD'" [dateFormat]="'jYYYY/jMM/jDD'">
                <input id="userExpiry" type="text" formControlName="strEsterakEndDate" class="form-control text-end" readonly>
              </ng-persian-datepicker>
              </div>
            </div>
            <fieldset class="col-12 col-md-6">
              <legend class="form-label">وضعیت حساب</legend>
              <div class="d-flex flex-wrap gap-3 pt-2">
                <label class="d-flex align-items-center gap-2" for="userEnabled">
                  <input id="userEnabled" formControlName="bEnable" value="true" class="form-check-input m-0" type="radio" name="bEnable">فعال
                </label>
                <label class="d-flex align-items-center gap-2" for="userDisabled">
                  <input id="userDisabled" formControlName="bEnable" value="false" class="form-check-input m-0" type="radio" name="bEnable">غیرفعال
                </label>
              </div>
            </fieldset>
          </div>
        </ng-container>
      </div>
      <div class="modal-footer gap-2">
        <button type="button" class="btn" data-bs-dismiss="modal">بستن</button>
        <button *ngIf="showUserDetails" type="button" class="btn btn-primary" (click)="isEditing ? updateUser() : addUser()">{{ isEditing ? 'ویرایش' : 'ثبت' }}</button>
      </div>
    </div>
  </div>
</div>
<!--car Modal-->
<div class="modal fade rtl user-dialog user-dialog--wide" dir="rtl" id="carModal" tabindex="-1" aria-labelledby="carModalTitle" aria-describedby="carModalDescription" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-xl">
        <div class="modal-content">
            <div class="modal-header dirI">
                <div>
                  <h2 class="modal-title" id="carModalTitle">اختصاص خودرو</h2>
                  <p id="carModalDescription" class="muted mt-1 mb-0">خودروهای مجاز این کاربر را انتخاب کنید؛ تغییر هر گزینه به‌صورت مستقیم اعمال می‌شود.</p>
                </div>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="بستن"></button>
            </div>
            <div class="modal-body ">
                <div class="row g-3 mb-3">
                  <div class="col-12 col-lg-7">
                    <label for="filterModal" class="form-label small text-muted">جستجوی خودرو</label>
                    <div class="user-search mb-0">
                      <i class="fa fa-search filter-icon" aria-hidden="true"></i>
                      <input id="filterModal" type="search" class="form-control" (input)="searchVehicles($event.target)"
                        placeholder="جستجو در جدول: نام راننده، کد خودرو، شماره موبایل، حوزه خدمت...">
                    </div>
                  </div>
                  <div class="col-12 col-lg-5">
                    <label for="saveUserModalSearch2" class="form-label small text-muted">حوزهٔ خدمت</label>
                    <div class="user-search mb-0">
                      <i class="fa fa-search filter-icon" aria-hidden="true"></i>
                      <input id="saveUserModalSearch2" type="search" class="form-control" (keyup)="searchVehicleDomains($event.target)"
                        placeholder="جستجو بر اساس حوزهٔ خدمت">
                    </div>
                  </div>
                </div>
                <div class="user-bulk-toolbar">
                  <span *ngIf="assignedVehicleCount >= 0" class="user-selection-count">انتخاب‌شده: {{ assignedVehicleCount | number | faNum }} مورد</span>
                  <div class="d-flex flex-wrap gap-2">
                    <button type="button" class="btn btn-outline-secondary rounded-pill" (click)="setVehicleAssignments(true)">اختصاص همه</button>
                    <button type="button" class="btn text-danger rounded-pill" (click)="setVehicleAssignments(false)">لغو اختصاص همه</button>
                    <button type="button" class="btn btn-outline-secondary rounded-pill" *ngIf="permissions?.bSendSMS2MobilesUser"
                      data-bs-toggle="modal" data-bs-target="#SmsModal">ارسال پیامک</button>
                  </div>
                </div>
                <div class="table-wrap table-responsive">
                    <table class="table table-hover align-middle" id="exel-car">
                        <thead >
                            <tr class="text-center f14">
                                <th scope="col" >#</th>
                                <th scope="col"  (click)="toggleAssignedVehicles()">اختصاص</th>
                                <th scope="col" >نام راننده</th>
                                <th scope="col" >کد شناسایی خودرو</th>
                                <th scope="col" >شماره موبایل راننده</th>
                                <th scope="col" >حوزه خدمت</th>
                                <th scope="col" >گروه خودرو</th>
                                <th scope="col" >پلاک</th>
                                <th scope="col" >تاریخ پایان اعتبار</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr class="text-center f12" *ngFor="let item of visibleVehicles;let i=index">
                                <td >{{i+1 | faNum}}</td>
                                <td >
                                    <input class="form-check-input" type="checkbox" [attr.aria-label]="'اختصاص: ' + (item.strComment || item.strFullName || item.strUnitID)" value="" checked
                                        *ngIf="item.bHas!=0" (click)="toggleVehicleAssignment(item.strUnitID)">
                                    <input class="form-check-input" type="checkbox" [attr.aria-label]="'اختصاص: ' + (item.strComment || item.strFullName || item.strUnitID)" value="" *ngIf="item.bHas==0"
                                        (click)="toggleVehicleAssignment(item.strUnitID)">
                                    <span class="d-none" *ngIf="item.bHas!=0">true</span>
                                    <span class="d-none" *ngIf="item.bHas==0">false</span>
                                </td>
                                <td  >{{item.strFullName}}</td>
                                <td  >{{item.strUnitID | faNum}}</td>
                                <td  >{{item.strSystemUser_strMobile | faNum}}</td>
                                <td  >{{item.strMobileDomain_strComment | faNum}}</td>
                                <td  >{{item.strMobileGroup_strComment | faNum}}</td>
                                <td  >{{otherService.returnCorrectPlate(item.strVehicleNo |
                                    faNum)}}</td>
                                <td  >{{item.strValidDate | faNum}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="modal-footer gap-2">
                <button type="button" class="btn" data-bs-dismiss="modal">بستن</button>
                <button type="button" class="btn btn-outline-secondary" (click)="exportExcel('exel-car')">خروجی اکسل</button>
            </div>
        </div>
    </div>
</div>
<!--Access-->
<div class="modal fade rtl user-dialog user-dialog--permissions" dir="rtl" id="access" tabindex="-1" aria-labelledby="accessTitle" aria-describedby="accessDescription" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg">
        <div class="modal-content">
            <div class="modal-header dirI">
                <div>
                  <h2 class="modal-title" id="accessTitle">مدیریت دسترسی‌ها</h2>
                  <p id="accessDescription" class="muted mt-1 mb-0">مجوزهای دسترسی کاربر را مدیریت کنید؛ تغییر هر گزینه به‌صورت مستقیم اعمال می‌شود.</p>
                </div>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="بستن"></button>
            </div>
            <div class="modal-body">
                <label for="saveUserModalSearch3" class="form-label small text-muted">جستجوی مجوز</label>
                <div class="user-search">
                  <i class="fa fa-search filter-icon" aria-hidden="true"></i>
                  <input id="saveUserModalSearch3" type="search" class="form-control" (keyup)="searchPermissions($event.target)"
                    placeholder="جستجو در جدول: نوع دسترسی...">
                </div>
                <div class="user-bulk-toolbar">
                  <button type="button" class="btn btn-outline-secondary" (click)="setPermissionAssignments(true)">انتخاب همه</button>
                  <button type="button" class="btn text-danger rounded-pill" (click)="setPermissionAssignments(false)">لغو اختصاص همه</button>
                </div>
                <div class="user-permission-list">
                  <label class="user-permission" *ngFor="let item of visiblePermissions">
                    <input class="form-check-input" type="checkbox" [checked]="item.bHas != 0"
                      (change)="togglePermission(item.strXenotakAbility)">
                    <span>{{ item.strComment }}</span>
                  </label>
                </div>
            </div>
            <div class="modal-footer gap-2"><button type="button" class="btn" data-bs-dismiss="modal">بستن</button></div>
        </div>
    </div>
</div>
<!--ارسال پیامک-->
<div class="modal fade rtl user-dialog user-dialog--compact" dir="rtl" id="SmsModal" tabindex="-1" aria-labelledby="SmsModalTitle" aria-describedby="SmsModalDescription" aria-hidden="true">
    <div class="modal-dialog modal-dialog-scrollable modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <div>
                  <h2 class="modal-title  ms-0" id="SmsModalTitle">ارسال پیامک</h2>
                  <p id="SmsModalDescription" class="muted mt-1 mb-0">پیام خود را برای کاربر وارد کنید.</p>
                </div>
                <button type="button" class="btn-close " data-bs-dismiss="modal" aria-label="بستن"></button>
            </div>
            <div class="modal-body">
                <div class="user-field" [formGroup]="smsForm">
                    <label for="smsTxt" class="form-label">متن پیام</label>
                    <textarea formControlName="strSMS" placeholder="متن پیامک را وارد کنید" class="form-control mx-auto " id="smsTxt"
                        rows="5"></textarea>
                </div>
            </div>
            <div class="modal-footer gap-2">
                <button type="button" class="btn" data-bs-toggle="modal"
                    data-bs-target="#carModal">برگشت</button>
                <button type="button" class="btn btn-primary" (click)="sendSms()">ارسال پیام</button>
            </div>
        </div>
    </div>
</div>
<!--User Activity-->
<div dir="rtl" class="modal fade rtl user-dialog user-dialog--wide" id="userActive" tabindex="-1" aria-labelledby="userActiveTitle" aria-describedby="userActiveDescription" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-xl">
        <div class="modal-content">
            <div class="modal-header">
                <div>
                  <h2 class="modal-title" id="userActiveTitle">فعالیت کاربر</h2>
                  <p id="userActiveDescription" class="muted mt-1 mb-0">سوابق ورود و اقدامات ثبت‌شدهٔ کاربر را بررسی کنید.</p>
                </div>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="بستن"></button>
            </div>
            <div class="modal-body ">
                <div class="user-search">
                  <i class="fa fa-search filter-icon" aria-hidden="true"></i>
                  <input class="form-control" type="search" aria-label="جستجو در سابقه فعالیت"
                    placeholder="جستجو در جدول: تاریخ، نوع اقدام..." (keyup)="searchActivity($event)">
                </div>
                <div class="table-wrap table-responsive">
                    <table class="table table-hover align-middle" id="excel-table-area-log">
                        <thead>
                            <tr class="text-center f14 ">
                                <th scope="col">#</th>
                                <th scope="col">نام</th>
                                <th scope="col">نوع اقدام</th>
                                <th scope="col">تاریخ</th>
                                <th scope="col">زمان</th>
                                <th scope="col">توضیحات</th>
                                <th scope="col">IP</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr class="text-center pointer f12 " *ngFor="let item of visibleActivity;let i=index ">
                                <td >{{i+1|faNum}}</td>
                                <td >{{item.strFullName}}</td>
                                <td >{{item.strActionType_strComment}}</td>
                                <td >{{item.strDate|faNum}}</td>
                                <td >{{item.strTime|faNum}}</td>
                                <td >{{item.strAddress |faNum}}</td>
                                <td ><a class="text-decoration-none text-primary pointer" target="_blank" rel="noopener noreferrer" href="https://whatismyipaddress.com/ip/{{item.strIP}}">{{item.strIP |faNum}}</a></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="modal-footer gap-2">
                <button type="button" class="btn" data-bs-dismiss="modal">بستن</button>
                <button type="button" class="btn btn-outline-secondary" (click)="exportExcel('excel-table-area-log')">خروجی اکسل</button>
            </div>
        </div>
    </div>
</div>
<!-- Define School -->
<div class="modal fade rtl user-dialog user-dialog--list" dir="rtl" id="defineSchool" tabindex="-1" aria-labelledby="defineSchoolTitle" aria-describedby="defineSchoolDescription" aria-hidden="true">
    <div class="modal-dialog modal-dialog-scrollable modal-lg modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <div>
                  <h2 class="modal-title  ms-0" id="defineSchoolTitle">  {{!isSchoolMode ? ' تعیین حوزه خدمت ' : 'تعیین مدارس کاربر' }}</h2>
                  <p id="defineSchoolDescription" class="muted mt-1 mb-0">{{ isSchoolMode ? 'مدارس مرتبط با کاربر را انتخاب کنید؛ تغییرات مستقیم اعمال می‌شوند.' : 'برای تعیین حوزهٔ خدمت، روی نام آن کلیک کنید.' }}</p>
                </div>
                <button type="button" class="btn-close " data-bs-dismiss="modal" aria-label="بستن"></button>
            </div>
            <div class="modal-body" dir="rtl">
                <div class="row g-3">
                    <div class="col-12">
                      <div class="user-search"><i class="fa fa-search filter-icon" aria-hidden="true"></i><input type="search" #domainSearch (input)="searchDomains(domainSearch.value)" class="form-control" aria-label="جستجوی حوزه خدمت یا مدرسه" placeholder="جستجو در جدول: حوزهٔ خدمت، مدرسه...">
                    </div>
                    </div>
                    <div class="table-wrap table-responsive">
                        <table class="table table-hover align-middle">
                            <thead>
                                <tr class="col-12 text-start">
                                    <th *ngIf="isSchoolMode"> اختصاص </th>
                                    <th> {{!isSchoolMode ? 'حوزه خدمت' : 'نام مدرسه' }} </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr [ngClass]="!isSchoolMode ? 'pointer' : '' " (click)="!isSchoolMode ? selectDomain(item) : '' " class="text-start col-12 " *ngFor="let item of visibleDomains;let i = index">
                                    <td *ngIf="isSchoolMode"><input type="checkbox" aria-label="اختصاص مورد" (change)="setDomainAssignment($event.target.checked,item)" [checked]="item.bSelected == 1 ? true : false "></td>
                                    <td>
                                      <button *ngIf="!isSchoolMode" type="button" class="btn btn-link text-decoration-none text-reset p-0 text-end">{{ item.strComment | faNum }}</button>
                                      <span *ngIf="isSchoolMode">{{ item.strCombinedDescription | faNum }}</span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div class="modal-footer gap-2"><button type="button" class="btn" data-bs-dismiss="modal">بستن</button></div>
        </div>
    </div>
</div>
<!-- supervision_service -->
<div class="modal fade rtl user-dialog user-dialog--list" dir="rtl" id="supervision_service" tabindex="-1" aria-labelledby="supervision_serviceTitle" aria-describedby="supervision_serviceDescription" aria-hidden="true">
    <div class="modal-dialog modal-dialog-scrollable modal-xl modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <div>
                  <h2 class="modal-title  ms-0" id="supervision_serviceTitle"> تعیین حوزه های خدمتی تحت نظارت کاربر </h2>
                  <p id="supervision_serviceDescription" class="muted mt-1 mb-0">حوزه‌های خدمتی تحت نظارت کاربر را انتخاب کنید؛ تغییرات مستقیم اعمال می‌شوند.</p>
                </div>
                <button type="button" class="btn-close " data-bs-dismiss="modal" aria-label="بستن"></button>
            </div>
            <div class="modal-body" dir="rtl">
                <div class="row g-3">
                    <div class="col-12">
                      <div class="user-search"><i class="fa fa-search filter-icon" aria-hidden="true"></i><input type="search" #search2 (input)="searchDomains(search2.value)" class="form-control" aria-label="جستجوی حوزه خدمت یا مدرسه" placeholder="جستجو در جدول: حوزهٔ خدمت، مدرسه...">
                    </div>
                    </div>
                    <div class="table-wrap table-responsive">
                        <table class="table table-hover align-middle">
                            <thead>
                                <tr class="col-12 text-center">
                                    <th > اختصاص </th>
                                    <th> حوزه خدمت </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr  class="text-center col-12 " *ngFor="let item of visibleDomains;let i = index">
                                    <td ><input type="checkbox" aria-label="اختصاص مورد" (change)="setDomainAssignment($event.target.checked,item,'supervision_service')" [checked]="item.bSelected == 1 ? true : false "></td>
                                    <td>{{item.strComment | faNum}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div class="modal-footer gap-2"><button type="button" class="btn" data-bs-dismiss="modal">بستن</button></div>
        </div>
    </div>
</div>
<!-- گروه کاربری -->
<div class="modal fade rtl user-dialog user-dialog--compact" dir="rtl" id="Access_Modal" tabindex="-1" aria-labelledby="Access_ModalTitle" aria-describedby="Access_ModalDescription" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg">
        <div class="modal-content dirI">
            <div class="modal-header dirI">
                <div>
                  <h2 class="modal-title" id="Access_ModalTitle"> گروه کاربری </h2>
                  <p id="Access_ModalDescription" class="muted mt-1 mb-0">برای اختصاص گروه کاربری، روی عنوان گروه موردنظر کلیک کنید.</p>
                </div>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="بستن"></button>
            </div>
            <div class="modal-body">
                <div class="user-choice-list">
                  <p *ngIf="!userGroups?.length" class="text-center text-muted py-4 mb-0" role="status">گروه کاربری برای نمایش وجود ندارد.</p>
                  <button type="button" class="user-choice" *ngFor="let item of userGroups" (click)="assignUserGroup(item)">
                    <span class="user-choice__icon" aria-hidden="true"><i class="fa fa-users"></i></span>
                    <span>{{ item.strComment }}</span>
                    <i class="fa fa-angle-left" aria-hidden="true"></i>
                  </button>
                </div>
            </div>
            <div class="modal-footer gap-2"><button type="button" class="btn" data-bs-dismiss="modal">بستن</button></div>
        </div>
    </div>
</div>
<!-- گروه کاربری -->
<div class="modal fade rtl user-dialog user-dialog--list" dir="rtl" id="GradeClass_Modal" tabindex="-1" aria-labelledby="GradeClass_ModalTitle" aria-describedby="GradeClass_ModalDescription" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg">
        <div class="modal-content dirI">
            <div class="modal-header dirI">
                <div>
                  <h2 class="modal-title" id="GradeClass_ModalTitle"> کلاس کاربر </h2>
                  <p id="GradeClass_ModalDescription" class="muted mt-1 mb-0">مدرسه، پایه و کلاس‌های مرتبط با کاربر را مدیریت کنید.</p>
                </div>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="بستن"></button>
            </div>
            <div class="modal-body">
                <div class="user-bulk-toolbar">
                    <button type="button" class="btn btn-primary rounded-pill" (click)="openAddUserClass()">
                        افزودن کلاس
                    </button>
                </div>
                <div class="table-wrap table-responsive mt-3">
                    <table class="table table-hover align-middle" >
                        <thead>
                            <tr class="">
                                <th class="text-center col-1"> # </th>
                                <th class="text-center"> عملیات </th>
                                <th class="text-center col-5"> مدرسه </th>
                                <th class="text-center"> پایه </th>
                                <th class="text-center"> کلاس </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr class="col-12 text-center pointer" *ngFor="let item of userClasses;let i = index">
                                <td> {{ i + 1 | faNum }} </td>
                                <td class="">
                                    <button type="button" class="btn btn-ghost text-danger" aria-label="حذف کلاس" (click)="deleteUserClass(item.iSchool_SystemUserGradeClass,i)"
                                      (mouseenter)="tooltip.show($event, 'حذف کلاس')" (mouseleave)="tooltip.hide()" (focus)="tooltip.show($event, 'حذف کلاس')" (blur)="tooltip.hide()">
                                      <i class="fa fa-trash" aria-hidden="true"></i>
                                    </button>
                                </td>
                                <td class="col-5"> {{ item.strCombinedDescription }} </td>
                                <td> {{ item.strGrade }} </td>
                                <td> {{ item.strTitel }} </td>
                            </tr>
                            <tr *ngIf="!userClasses?.length">
                                <td colspan="5" class="text-center text-muted py-4" role="status">کلاسی برای این کاربر ثبت نشده است.</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="modal-footer gap-2">
                <button type="button" class="btn" data-bs-dismiss="modal">
                     بستن
                </button>
            </div>
        </div>
    </div>
</div>
<!--  -->
<div class="modal fade rtl user-dialog user-dialog--compact" dir="rtl" id="UserClassModal" tabindex="-1" aria-labelledby="UserClassModalTitle" aria-describedby="UserClassModalDescription" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
        <div class="modal-content dirI">
            <div class="modal-header dirI">
                <div>
                  <h2 class="modal-title" id="UserClassModalTitle">افزودن کلاس کاربر</h2>
                  <p id="UserClassModalDescription" class="muted mt-1 mb-0">مدرسه، پایه و کلاس موردنظر را انتخاب و ثبت کنید.</p>
                </div>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="بستن"></button>
            </div>
            <div class="modal-body">
                    <div [formGroup]="userClassForm" class="row g-3">
                        <!-- مدرسه -->
                        <div *ngIf="visibleDomains.length" class="col-12">
                            <label class="form-label small text-muted"> مدرسه </label>
                                <custom-filter
                                    [strComment]="'strComment'"
                                    [str_Placeholder]="'نام مدرسه را جستجو کنید'"
                                    [lst_Main]="visibleDomains"
                                    [lst_SearchKey]="['strComment']"
                                    [isDisabled]="false"
                                    (hideOptions)="userClassForm.get('iMobileDomain')?.setValue($event?.iMobileDomain || '')">
                                </custom-filter>
                        </div>
                        <!-- پایه -->
                        <div class="col-12">
                            <div class="user-field">
                                <label class="form-label" for="saveUserGrade">پایه</label>
                            <select id="saveUserGrade" class="form-select" formControlName="tiGrade">
                                <option class="text-center" value="-1"> انتخاب کنید </option>
                                <option class="text-center" *ngFor="let item of grades" [value]="item.tiGrade">
                                    {{item.strGrade}}
                                </option>
                            </select>
                            </div>
                        </div>
                        <!-- کلاس -->
                        <div class="col-12">
                            <div class="user-field">
                                <label class="form-label" for="saveUserClass">کلاس</label>
                            <select id="saveUserClass" class="form-select" formControlName="tiClassNo">
                                <option class="text-center" value="-1"> انتخاب کنید </option>
                                <option class="text-center" *ngFor="let item of classes" [value]="item.tiClassNo">
                                    {{item.strTitel}}
                                </option>
                            </select>
                            </div>
                        </div>
                    </div>
            </div>
            <div class="modal-footer gap-2">
                <button type="button" class="btn" data-bs-dismiss="modal">
                     بستن
                </button>
                <button type="button" class="btn btn-primary" (click)="saveUserClass()">
                      ثبت
                </button>
            </div>
        </div>
    </div>
</div>
